import script from "./HostingHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HostingHeader.vue?vue&type=script&setup=true&lang=js"

import "./HostingHeader.vue?vue&type=style&index=0&id=caab42f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caab42f2"]])

export default __exports__